
export class AppError {
    constructor(public originalError?: any) {}
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/pages/common/app-error.ts